import { Copy, Pencil, Send, Trash2 } from "lucide-react";
import { formatPrice } from "@/lib/store";

const when = (iso) => (iso ? new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "");
const iconBtn = "flex items-center gap-1.5 rounded-full border border-white/15 px-3 py-1.5 text-xs font-semibold text-zinc-100 transition-colors hover:bg-white/10";

const summary = (d) => {
  const t = d.totals || {};
  if (t.change > 0) return <>Volta para o cliente: <strong className="text-emerald-300">{formatPrice(t.change)}</strong></>;
  if ((d.trade || []).length) return <>Diferença: <strong className="text-white">{t.difference > 0 ? formatPrice(t.difference) : "R$ 0,00"}</strong></>;
  return <>Total: <strong className="text-white">{formatPrice(t.wanted_total)}</strong></>;
};

// Propostas salvas: reenviar, copiar, editar ou apagar.
export const ProposalHistory = ({ list, onResend, onCopy, onEdit, onDelete }) => (
  <div data-testid="proposal-history" className="mt-8 border-t border-white/10 pt-6">
    <p className="text-sm font-semibold text-white">Propostas salvas <span className="font-normal text-zinc-400">({list.length})</span></p>
    {!list.length && <p className="mt-3 text-sm text-zinc-400">Nenhuma proposta salva ainda.</p>}
    <ul data-lenis-prevent className="mt-3 max-h-[480px] space-y-2 overflow-y-auto pr-1">
      {list.map((d) => (
        <li key={d.id} data-testid={`proposal-item-${d.id}`} className="rounded-2xl border border-white/10 p-4">
          <div className="flex flex-wrap items-baseline justify-between gap-2">
            <p className="font-semibold text-white">{d.client_name || "Cliente sem nome"}{d.client_phone && <span className="ml-2 text-sm font-normal text-zinc-400">{d.client_phone}</span>}</p>
            <p className="text-xs text-zinc-400">{when(d.updated_at)}{d.sent_count > 0 ? ` · enviada ${d.sent_count}x` : " · não enviada"}</p>
          </div>
          <p className="mt-1 truncate text-sm text-zinc-300">{(d.wanted || []).map((w) => w.label).join(" + ")}{(d.trade || []).length ? ` · troca: ${d.trade.map((x) => x.label).join(" + ")}` : ""}</p>
          <p className="mt-1 text-sm text-zinc-300">{summary(d)}</p>
          <div className="mt-3 flex flex-wrap gap-2">
            <button type="button" data-testid={`proposal-resend-${d.id}`} onClick={() => onResend(d)} className={`${iconBtn} border-[#25D366]/50 text-[#25D366]`}><Send className="h-3.5 w-3.5" /> Reenviar</button>
            <button type="button" data-testid={`proposal-copy-${d.id}`} onClick={() => onCopy(d)} className={iconBtn}><Copy className="h-3.5 w-3.5" /> Copiar</button>
            <button type="button" data-testid={`proposal-edit-${d.id}`} onClick={() => onEdit(d)} className={iconBtn}><Pencil className="h-3.5 w-3.5" /> Editar</button>
            <button type="button" data-testid={`proposal-delete-${d.id}`} onClick={() => onDelete(d)} className={`${iconBtn} text-red-300`}><Trash2 className="h-3.5 w-3.5" /> Apagar</button>
          </div>
        </li>
      ))}
    </ul>
  </div>
);
